import { BaseEntity } from './base-entity';
import { Question } from './question';

export class Threat extends BaseEntity {
  description: string;
  riskTemplate?: BaseEntity;
  threatType: BaseEntity;
  questions: Array<Question> = [];
  isPlanRequired: boolean;
}
